import { SxProps, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix="$"
        placeholder="$x,xxx"
      />
    );
  }
);
interface SpendInputProps {
  autoFocus?: boolean;
  label?: string;
  fullWidth?: boolean;
  id: string;
  isValid: boolean;
  helperText?: string;
  onChange: (value: number | string) => void;
  sx?: SxProps;
  value: number | null;
  maxLength?: number;
}

const SpendInput = ({
  autoFocus,
  label = undefined,
  fullWidth,
  id,
  isValid,
  helperText = 'Please choose a value below $100,000.',
  onChange,
  sx,
  value,
  maxLength = 7,
}: SpendInputProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e?.target;
      onChange(value);
    },
    [onChange]
  );
  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      error={!isValid}
      helperText={!isValid && helperText}
      id={id}
      inputRef={(input) => autoFocus && input && input.focus()}
      inputProps={{ maxLength }}
      InputProps={{
        inputComponent: NumericFormatCustom as any,
      }}
      onChange={handleChange}
      onFocus={(e) =>
        e.currentTarget?.setSelectionRange(
          e.currentTarget.value.length,
          e.currentTarget.value.length
        )
      }
      size="small"
      sx={sx}
      variant="outlined"
      value={value}
    />
  );
};

export default SpendInput;
